import { uniqueId } from 'lodash'
import { LinePaint } from 'maplibre-gl'
import { colors } from '../../styles/colors'

type Step = {
  DurationSeconds: number
  Distance: number
  StartPosition: [number, number]
  EndPosition: [number, number]
  GeometryOffset: number
}

type Leg = {
  Steps: Step[]
  DurationSeconds: number
  Distance: number
  StartPosition: [number, number]
  EndPosition: [number, number]
  Geometry: {
    LineString: [number, number][]
  }
}

type Summary = {
  DataSource: string
  Distance: number
  DistanceUnit: 'Miles' | string
  DurationSeconds: number
  RouteBBox: [number, number, number, number]
}

export type RouteType = {
  Legs: Leg[]
  Summary: Summary
}

export const createRoute = ({
  routeJSON,
  multiLayer = false,
  paint = {
    'line-color': colors.routeColor,
    'line-width': colors.routeWidth,
  },
  preferredId,
  arrayOfCoordinates,
}: {
  routeJSON?: string
  multiLayer?: boolean
  preferredId?: string
  arrayOfCoordinates?: [number, number][]
  paint?: LinePaint
}) => {
  const randomSource = uniqueId('source_')
  const randomLayer = uniqueId('layer_')

  let coordinates: [number, number][] = []
  if (routeJSON) {
    const route: RouteType = JSON.parse(routeJSON)

    coordinates = route.Legs.reduce((acc: [number, number][], leg) => {
      acc.push(...leg.Geometry.LineString)

      return acc
    }, [])
  } else if (arrayOfCoordinates) {
    coordinates = arrayOfCoordinates
  }

  const source = {
    type: 'geojson',
    data: {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'LineString',
        coordinates,
      },
    },
  }

  const layer = {
    id: multiLayer ? (preferredId ? preferredId : randomLayer) : 'route',
    type: 'line',
    source: randomSource,
    layout: {
      'line-join': 'round',
      'line-cap': 'round',
    },
    paint,
  }

  return {
    id: randomSource,
    source: source as maplibregl.AnySourceData,
    layer: layer as maplibregl.AnyLayer,
  }
}
